<script lang="ts">
	import type { Widget } from '$lib/model/business';
	import WidgetHeader from '$lib/widget/components/WidgetHeader.svelte';
	import { getFontUrls, updateWidgetTheme, type WidgetContent } from '$lib/widget/helper/widget';
	import { widgetColors, widgetConfig, widgetContent } from '$lib/widget/stores';

	interface Props {
		config: Widget;
		content?: WidgetContent | undefined;
		children?: import('svelte').Snippet;
		preview?: boolean;
		hideHeader?: boolean;
	}

	let {
		config,
		content = undefined,
		children,
		preview = false,
		hideHeader = false
	}: Props = $props();

	$effect(() => {
		if (content && preview) {
			$widgetContent = content;
		}
	});

	$effect(() => {
		if (config && preview) {
			$widgetConfig = config;
			$widgetColors = config.theme;
		}
	});

	$widgetConfig = config;
	$widgetColors = config.theme;

	$effect(() => {
		updateWidgetTheme($widgetColors);
	});
	let fontUrls = $derived(getFontUrls($widgetColors.fontFamily));
	let fontClass = $derived(
		$widgetColors.fontFamily !== 'default' ? `font-${$widgetColors.fontFamily}` : ''
	);
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	{#if fontUrls}
		{#each fontUrls as fontUrl}
			<link href={fontUrl} rel="stylesheet" />
		{/each}
	{/if}
</svelte:head>

<!-- Background -->
{#if $widgetContent}
	<div
		class="flex justify-center flex-1 w-full h-full relative {fontClass} overflow-auto bg-widget-background text-widget-background-on dark:bg-widget-background-dark dark:text-widget-background-on-dark"
		id="reservatoo-viewport"
	>
		<!-- Widget Centered Frame -->
		<div class="flex flex-col flex-1 max-w-5xl w-full h-full gap-2 sm:gap-5">
			<div class="flex flex-col text-center w-full lg:justify-center">
				{#if !hideHeader}
					<WidgetHeader {preview} />
				{/if}
				<!-- Main content -->
				<main
					class="text-center w-full flex flex-col lg:flex-row-reverse lg:min-h-96 justify-center"
				>
					<div class="flex-grow {preview ? '' : 'px-2'}">
						{@render children?.()}
					</div>
				</main>
			</div>
		</div>
	</div>
{/if}
